// extracted by mini-css-extract-plugin
module.exports = {"timeDisplay":"new_pause_prompt_form-module__timeDisplay___2w2zZ"};